import Vue from 'vue';
import {LibEventBus} from '@marilyn/marilyn-ui';

/**
 * AppEventBus - event bus for app global events:
 *  - window resize
 */
const AppEventBus = new Vue();

AppEventBus.$on('PAGE_RESIZE', () => {
  LibEventBus.$emit('PAGE_RESIZE');
});

export {AppEventBus};

export default AppEventBus;
